import { createFileRoute } from "@tanstack/react-router";
import { AmbassadorAccountPage } from "../../features/ambassadors/pages/ambassador-account-page";
import { isOnboardingReason, type OnboardingReason } from "../../features/ambassadors/lib/onboarding-reason";

// `account_`: its own page, not nested in the account tabs (which render no outlet).
export const Route = createFileRoute("/_authed/account_/ambassador")({
  // The onboarding step, so refresh and Back keep the place, and why a
  // refused finish sent the ambassador back to it. On the dashboard,
  // `edit=page` keeps the page editor open through a refresh.
  validateSearch: (
    search: Record<string, unknown>,
  ): { step?: 2 | 3; reason?: OnboardingReason; edit?: "page" } => {
    const n = Number(search.step);
    const reason = isOnboardingReason(search.reason) ? search.reason : undefined;
    return {
      ...(n === 2 || n === 3 ? { step: n } : {}),
      ...(reason ? { reason } : {}),
      ...(search.edit === "page" ? { edit: "page" as const } : {}),
    };
  },
  component: AmbassadorAccountPage,
});
